





import { Vue, Component } from 'nuxt-property-decorator';
import CeSystimeIaelementsMemorygame from '../CeSystimeIaelementsMemorygame.vue';

@Component({
  components: { CeSystimeIaelementsMemorygame }
})
export default class MemoryGame extends Vue {
  get memorygameComponent() {
    return CeSystimeIaelementsMemorygame;
  }
}
